document.addEventListener('DOMContentLoaded', () => {
    const videoControls = () => {
        const videoContainers = document.querySelectorAll('.jdg-media-video-container');

        if ( !videoContainers.length ) {
            return;
        }

        videoContainers.forEach((videoContainer) => {
            const video = videoContainer.querySelector('.jdg-media-video');
            const control = videoContainer.querySelector('#jdg-video-button');
            const a11yText = control.querySelector('.jdg-accessibly-hidden');
            const textPlay = control.getAttribute('data-text-play');
            const textPause = control.getAttribute('data-text-pause');

            const videoPlayPause = (event) => {
                event.stopPropagation();
                video.paused ? video.play() : video.pause();

                if( textPause == a11yText.innerHTML ) {
                    a11yText.innerHTML = textPlay;
                    control.classList.remove('jdg-video-control--pause');
                } else {
                    a11yText.innerHTML = textPause;
                    control.classList.add('jdg-video-control--pause');
                }
            };

            control.addEventListener('click', videoPlayPause);
        });
    };

    videoControls();

});